export const mcBookSearchFields: any = reactive({
  id: '',
  fullName: '',
  mobile: '',
  landline: '',
  email: '',
  designation: '',
})

export const resetMcBookSearchFields = { ...mcBookSearchFields }

export const mcBookHeaders = [
  {
    title: 'ID',
    key: 'id',
  },
  {
    title: 'Full Name',
    key: 'fullName',
  },
  {
    title: 'Mobile No.',
    key: 'mobile',
    align: 'start',
  },
  {
    title: 'Landline No.',
    key: 'landline',
    align: 'start',
  },

  // {
  //   title: 'Email Address',
  //   key: 'email',
  //   align: 'start',
  //   sortable: false,
  // },
  {
    title: 'Designation',
    key: 'designation',
    align: 'start',
  },
  {
    title: 'Associated With',
    key: 'workableType',
    align: 'start',
  },
  {
    title: 'Business Name',
    key: 'businessName',
    align: 'start',
  },
  {
    title: 'Balance',
    key: 'balance',
    align: 'start',
  },
  {
    title: 'Created Timestamp',
    key: 'createdAt',
    align: 'start',
  },
  {
    title: 'Updated Timestamp',
    key: 'updatedAt',
    align: 'start',
  },
  {
    title: 'Actions',
    key: 'actions',
    sortable: false,
    align: 'center',
  },
]

export const usersMcBookHeaders = [
  {
    title: 'ID',
    key: 'id',
  },
  {
    title: 'Full Name',
    key: 'fullName',
  },
  {
    title: 'Mobile No.',
    key: 'mobile',
    align: 'start',
  },
  {
    title: 'Landline No.',
    key: 'landline',
    align: 'start',
  },

  // {
  //   title: 'Email Address',
  //   key: 'email',
  //   align: 'start',
  //   sortable: false,
  // },
  {
    title: 'Designation',
    key: 'designation',
    align: 'start',
  },
  {
    title: 'Balance',
    key: 'balance',
    align: 'start',
  },
  {
    title: 'Created Timestamp',
    key: 'createdAt',
    align: 'start',
  },
  {
    title: 'Updated Timestamp',
    key: 'updatedAt',
    align: 'start',
  },
  {
    title: 'Actions',
    key: 'actions',
    sortable: false,
    align: 'center',
  },
]
